<div class="table-content-component-panel-monitoreo" style="position: relative">
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" name="loadingEventList" size="medium" color="#fff" type="ball-pulse"
    [fullScreen]="false">
    <p style="color: white" #loadingSpinner>
      Cargando Eventos...
    </p>
  </ngx-spinner>
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" name="loadingOperators" size="medium" color="#fff" type="ball-pulse"
    [fullScreen]="false">
    <p style="color: white" #loadingSpinner>
      Cargando Eventos ...
    </p>
  </ngx-spinner>
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" name="loadingVehiculos" size="medium" color="#fff" type="ball-pulse"
    [fullScreen]="false">
    <p style="color: white" #loadingSpinner>
      {{'VEHICLES.MESSAGE.LOADING' | translate}}
    </p>
  </ngx-spinner>

  <div *ngIf="eventService.eventDeveloperStatus">
    <div class="">
      <label>Debug Servicio Event</label>
    </div>
    <div class="">
      <label for="">imei de unidad:</label>
      <input [(ngModel)]="imei_debug" type="text" name="" value="864200050708453" />
    </div>
    <div class="">
      <button type="button" name="button">Terminar Debug</button>
      <button (click)="clickDatosDebug()" type="button" name="button">
        Ver datos IMEI
      </button>
      <button (click)="clickEndDeveloper()" type="button" name="button">
        Terminar modo Desarrolador
      </button>
    </div>
    <div class="">
      <ul>
        <li *ngFor="let debug of data_debug">
          {{ debug }}
        </li>
      </ul>
    </div>
  </div>
  <div class="card-body p-fluid" id="rowBusqueda"
    *ngIf="eventService.config.showEventSelector || eventService.config.showVehicleSelector">
    <!-- <ng-container *appHasPermission="'events_filter_by_group'"> -->
    <!-- Row 1: Filters (Operation, Group, Convoy) -->
    <div class="row mb-2" *ngIf="eventService.config.showGroupingSelector">
      <div class="col-sm-4 p-field">
        <label class="d-block mb-1" style="font-size: 0.8rem;">Operación:</label>
        <p-dropdown [options]="operations" [(ngModel)]="selectedOperation" [showClear]="true"
          optionLabel="nameoperation" optionValue="idoperation" (onChange)="onChangeOperation()"
          [placeholder]="placeholderOperation" [disabled]="disabledOperation" [style]="{'width':'100%'}"
          appendTo="body"></p-dropdown>
      </div>
      <div class="col-sm-4 p-field">
        <label class="d-block mb-1" style="font-size: 0.8rem;">Grupo:</label>
        <p-dropdown [options]="groups" [(ngModel)]="selectedGroup" [showClear]="true" optionLabel="namegrupo"
          optionValue="idgrupo" (onChange)="onChangeGroup()" [placeholder]="placeholderGroup" [disabled]="disabledGroup"
          [style]="{'width':'100%'}" appendTo="body"></p-dropdown>
      </div>
      <div class="col-sm-4 p-field">
        <label class="d-block mb-1" style="font-size: 0.8rem;">Convoy:</label>
        <p-dropdown [options]="convoys" [(ngModel)]="selectedConvoy" [showClear]="true" optionLabel="nameconvoy"
          optionValue="idconvoy" (onChange)="onChangeConvoy()" [placeholder]="placeholderConvoy"
          [disabled]="disabledConvoy" [style]="{'width':'100%'}" appendTo="body"></p-dropdown>
      </div>
    </div>
    <!-- </ng-container> -->

    <!-- Row 2: Selectors (Vehicles & Events) -->
    <div class="row">
      <!-- Vehicle Selector -->
      <div [ngClass]="{
            'col-sm-6': eventService.config.showEventSelector,
            'col-sm-12': !eventService.config.showEventSelector
          }" *ngIf="eventService.config.showVehicleSelector">
        <div class="p-field" style="width: 100%;">
          <label class="d-block mb-1" style="font-size: 0.8rem;">Vehículos:</label>
          <p-multiSelect [options]="vehiclesList" optionLabel="name" [showToggleAll]="true" dataKey="IMEI"
            [(ngModel)]="selectedVehicles" (onChange)="filterByVehicles()"
            [placeholder]="'EVENTS.LABELS.SELECT_VEHICLES' | translate"
            [selectedItemsLabel]="'{0} ' + ('EVENTS.LABELS.SELECTED_VEHICLES' | translate)" [filter]="true"
            filterBy="plate_number,cod_interno,name" [style]="{'width':'100%'}" appendTo="body">
          </p-multiSelect>
        </div>
      </div>

      <!-- Event Selector -->
      <div [ngClass]="{
            'col-sm-6': eventService.config.showVehicleSelector,
            'col-sm-12': !eventService.config.showVehicleSelector
          }" *ngIf="eventService.config.showEventSelector">
        <label class="d-block mb-1" style="font-size: 0.8rem;">Eventos:</label>
        <p-multiSelect [options]="eventService.eventsGroupedList" [group]="true" [(ngModel)]="selectedEvent"
          optionLabel="name" [defaultLabel]="'EVENTS.LABELS.NO_EVENTS_SELECTED' | translate"
          [selectedItemsLabel]="'{0} ' + ('EVENTS.LABELS.SELECTED_EVENTS' | translate)" [showToggleAll]="true"
          scrollHeight="250px" (onChange)="changeTypeEvent()" [appendTo]="'body'" [style]="{'width':'100%'}">
          <ng-template let-group pTemplate="group">
            <div class="p-d-flex p-ai-center">
              <span>{{ group.label }}</span>
            </div>
          </ng-template>
        </p-multiSelect>
      </div>
    </div>
  </div>

  <div class="panel-izq-table-container">
    <p-table [value]="events$ | async" selectionMode="single" (onRowExpand)="rowExpandend($event)" dataKey="uuid_event"
      [autoLayout]="true" [rowExpandMode]="'single'" [expandedRowKeys]="expandedRows" sortField="fecha_tracker"
      [sortOrder]="-1" sortMode="multiple">
      <ng-template pTemplate="header" class="visible-on-scroll">
        <tr>
          <th Column="name" (click)="clickEventPanel()" style="padding: 0.5rem 0.5rem 0.5rem 32px !important">
            {{'EVENTS.LABELS.EVENT_TYPE' | translate}}</th>
          <th Column="nombre">{{'FIELDS.NAME' | translate}}</th>
          <th Column="nombre_objeto">{{'COMMON.VEHICLE' | translate}}</th>
          <th Column="fecha_tracker">{{'FIELDS.DATE' | translate}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-event let-expanded="expanded">
        <tr tabindex="-1" (click)="switchEventOnMap(event, currRow)" [style]="{ 'font-size': '0.75rem' }" [ngClass]="{
            'unread-event': !event.viewed,
            'tr-selected':
              event.uuid_event == eventService.activeEvent.uuid_event,
            'evaluation-event': event.evaluated == 2,
            'evaluated-event': event.evaluated == 1
          }" [class]="getClassByEvent(event)" [pRowToggler]="event.bol_evaluation ? event : ''" #currRow
          [attr.id]="'event-' + event.uuid_event">
          <td>
            <div style="
                display: flex;
                gap: 8px;
                align-items: center;
                height: max-content;
              ">
              <button *ngIf="event.bol_evaluation" type="button" pButton pRipple
                class="p-button-rounded p-button-plain p-button-text" style="width: 18px"
                [icon]="expanded ? 'pi pi-circle-on' : 'pi pi-circle-off'" #rowToggle></button>
              <div class="event-column" style="
                  width: 100%;
                  line-height: 0.7rem;
                  max-height: 30px;
                  min-width: 168px;
                  max-width: 192px;
                  margin: auto;
                " [style]="
                  event.bol_evaluation ? 'margin: auto' : 'margin-left: 24px'
                ">
                <span style="text-align: center; text-overflow: ellipsis">
                  {{
                  getClassByEvent(event) === 'checklist-completed' ? 'CL completado' :
                  getClassByEvent(event) === 'checklist-no-completed' ? 'CL no completado' :
                  getClassByEvent(event) === 'checklist-danger' ? 'CL con observaciones' :
                  getClassByEvent(event) === 'checklist-waiting' ? 'CL en proceso' :
                  event.name
                  }}
                </span>
              </div>
            </div>
          </td>
          <td class="event-column-name">{{ event.nombre }}</td>
          <td>{{ event.nombre_objeto || "Unidad no registrada" }}</td>
          <td>{{ event.fecha_tracker }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-event>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" style="text-align: center">{{'COMMON.NO_MATCH' | translate}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>



  <!-- Advanced Search Floating Panel -->
  <div class="search-floating-panel" [ngClass]="{'show': showSearchPanel}">
    <div class="search-panel-content p-3">
      <div class="d-flex justify-content-between align-items-center">
        <h6 class="m-0 d-flex gap-2 align-items-center"><i class="fas fa-search-plus mr-2"></i>{{ 'Búsqueda Avanzada' }}</h6>
        <button class="btn-close" (click)="toggleSearchPanel()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="small italic">
        * El rango no puede superar 24 horas y la fecha de inicio no puede ser anterior a 90 días.
      </div>
      <div class="row mt-1 g-2">
        <div class="col-6">
          <label class="small text-muted d-block mb-1">Fecha Inicio</label>
          <p-calendar [(ngModel)]="searchStartDate" [showTime]="true" [showIcon]="true" [minDate]="minSearchDate"
            [maxDate]="maxSearchDate" dateFormat="dd/mm/yy" appendTo="body" styleClass="w-100"
            (ngModelChange)="onSearchStartDateChange($event)"></p-calendar>
        </div>
        <div class="col-6">
          <label class="small text-muted d-block mb-1">Fecha Fin</label>
          <p-calendar [(ngModel)]="searchEndDate" [showTime]="true" [showIcon]="true" [minDate]="minSearchDate"
            [maxDate]="maxSearchDate" dateFormat="dd/mm/yy" appendTo="body" styleClass="w-100"
            (ngModelChange)="onSearchEndDateChange($event)"></p-calendar>
        </div>
      </div>
      <div class="mt-3 text-center transition-wrapper">

        <button
          class="btn-search-confirm w-100"
          [class.hide-button]="showDateRangeWarning"
          (click)="searchEventsByDate()">
          Buscar Eventos
        </button>

        <div
          class="date-range-warning"
          [class.show-warning]="showDateRangeWarning">
          <i class="fas fa-exclamation-triangle"></i>
          <span>El rango se ajustó al máximo de 24 horas permitido.</span>
        </div>

      </div>
    </div>
  </div>

  <div
    class="show-more-container w-100 d-flex justify-content-between align-items-center"
    style="text-align: center; padding:.6rem .6rem; position: relative;">

    <div class="d-flex gap-2 flex-row">
      <button *appHasPermission="'events_panel_view_by_date_range'" (click)="toggleSearchPanel()" class="border-0 btn-action-event" title="Búsqueda por fecha">
        <i class="fas fa-search"></i>
      </button>

      <div class="d-flex gap-1" *appHasPermission="'events_btn_showmore'">
        <button (click)="showFirstEvent()" class="border-0 btn-action-event" title="Ir al inicio">
          <i class="fas fa-arrow-up"></i>
        </button>

        <button (click)="showLastEvent()" class="border-0 btn-action-event" title="Ir al final">
          <i class="fas fa-arrow-down"></i>
        </button>
      </div>
    </div>
    <ng-container  *appHasPermission="'events_btn_showmore'">
      <button class="btn-load-more" (click)="loadMore()" [disabled]="isLoadingMoreEvents || !canLoadMoreEvents">
        <i class="fas fa-plus-circle" [ngClass]="{'fa-spin': isLoadingMoreEvents}"></i>
        <span>{{'EVENTS.LABELS.SHOW_MORE_EVENTS' | translate}}</span>
      </button>
    </ng-container>
  </div>
</div>
